import { authenticationApi, AuthenticationApi } from './authentication';
import { clientApi, ClientApi } from './client';
import { germinationRoomApi, GerminationRoomApi } from './germinationRoom';
import { greenhouseApi, GreenhouseApi } from './greenhouse';
import { healingRoomApi, HealingRoomApi } from './healingRoom';
import { organizationApi, OrganizationApi } from './organization';
import { orderApi, OrderApi } from './order';
import { orderItemApi, OrderItemApi } from './orderItem';
import { productApi, ProductApi } from './product';
import { productionItemApi, ProductionItemApi } from './productionItem';
import { resourceApi, ResourceApi } from './resource';
import { seedingBatchApi, SeedingBatchApi } from './seedingBatch';
import { seedTicketApi, SeedTicketApi } from './seedTicket';
import { trayApi, TrayApi } from './tray';
import { userApi, UserApi } from './user';
import { vehicleApi, VehicleApi } from './vehicle';

interface ApiClient {
  authentication: AuthenticationApi,
  client: ClientApi,
  germinationRoom: GerminationRoomApi,
  greenhouse: GreenhouseApi,
  healingRoom: HealingRoomApi,
  organization: OrganizationApi
  order: OrderApi
  orderItem: OrderItemApi
  product: ProductApi,
  productionItem: ProductionItemApi,
  resource: ResourceApi,
  seedingBatch: SeedingBatchApi,
  seedTicket: SeedTicketApi,
  tray: TrayApi,
  user: UserApi,
  vehicle: VehicleApi,
}

export const apiClient: ApiClient = {
  authentication: authenticationApi,
  client: clientApi,
  germinationRoom: germinationRoomApi,
  greenhouse: greenhouseApi,
  healingRoom: healingRoomApi,
  organization: organizationApi,
  order: orderApi,
  orderItem: orderItemApi,
  product: productApi,
  productionItem: productionItemApi,
  resource: resourceApi,
  seedingBatch: seedingBatchApi,
  seedTicket: seedTicketApi,
  tray: trayApi,
  user: userApi,
  vehicle: vehicleApi,
};
